import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";

import Navbardesign from "../Components/Navbar";
import BannerSwiper from "../Components/Bannerdesign/Bannerdesign";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";
import HouseProjectSection from "../Components/LandingHouse/HouseProjectSection";

/* ---------------- LAZY LOAD ---------------- */
const Testimonials = lazy(
  () => import("../Components/Testimonalprocess/Testimonalsprocess"),
);

/* ---------------- API BASE ---------------- */
const API_BASE = "https://mithahomes.com/backend/api";
const BLOG_API = `${API_BASE}/blogs/frontend`;
const POPUP_API = `${API_BASE}/popmodelimage/popup-image`;
const VIEW_API = `${API_BASE}/apiviewcount`;
const IMAGE_BASE_URL = "https://mithahomes.com/backend";

const LandingPageHouseTrichy = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [popupType, setPopupType] = useState(null);
  const [popupBlogId, setPopupBlogId] = useState(null);
  const [popupProjectId, setPopupProjectId] = useState(null);

  /* ---------------- RESPONSIVE STATE ---------------- */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  /* ---------------- VIEW COUNT ---------------- */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    axios.post(`${VIEW_API}/view`).catch(() => { });
  }, []);

  /* ---------------- POPUP LOGIC ---------------- */
  useEffect(() => {
    const initPopup = async () => {
      try {
        const blogRes = await axios.get(BLOG_API);
        if (blogRes.data?.success && blogRes.data.blogs?.length > 0) {
          const blog = blogRes.data.blogs[0];
          if (blog?.image) {
            setPopupImage(`${IMAGE_BASE_URL}${blog.image}`);
            setPopupBlogId(blog.id);
            setPopupType("blog");
            setShowModal(true);
            return;
          }
        }

        const popupRes = await axios.get(POPUP_API);
        if (popupRes.data?.success && popupRes.data.data?.length > 0) {
          const active = popupRes.data.data.find(
            (i) => Number(i.is_active) === 1,
          );
          if (active?.image) {
            setPopupImage(`${IMAGE_BASE_URL}${active.image}`);
            setPopupProjectId(active.project_id);
            setPopupType("project");
            setShowModal(true);
          }
        }
      } catch (error) {
        console.error("Popup fetch error:", error);
      }
    };

    // initPopup();
  }, []);


  const handlePopupClick = () => {
    setShowModal(false);
    if (popupType === "blog") navigate(`/blog/${popupBlogId}`);
    if (popupType === "project") navigate(`/project/${popupProjectId}`);
  };

  return (
    <>
      {/* ---------------- SEO ---------------- */}
      <Helmet>
        <title>House for Sale in Trichy | Mitha Homes</title>
        <meta name="title" content="House for Sale in Trichy | Mitha Homes" />
        <meta
          name="description"
          content="Explore premium houses for sale in Trichy with Mitha Homes. Discover modern homes in prime locations with quality construction and great investment value."
        />
        <meta
          name="keywords"
          content="house for sale in trichy, 3 bhk house for sale in trichy, independent house for sale in trichy, new house for sale in trichy"
        />
        <link rel="canonical" href="https://www.mithahomes.com/house-for-sale-in-trichy/" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mithahomes.com/house-for-sale-in-trichy/" />
        <meta property="og:site_name" content="Mitha Homes" />
        <meta
          property="og:title"
          content="House for Sale in Trichy | Mitha Homes"
        />
        <meta
          property="og:description"
          content="Explore premium individual houses and villas for sale in Trichy with Mitha Homes. Find your dream home with top amenities across prime Trichy locations."
        />
        <meta
          property="og:image"
          content="https://mithahomes.com/backend/uploads/OG_banner_image.png"
        />
        <meta property="og:image:alt" content="Mitha Homes - House for Sale in Trichy" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.mithahomes.com/house-for-sale-in-trichy/" />
        <meta name="twitter:title" content="House for Sale in Trichy | Mitha Homes" />
        <meta
          name="twitter:description"
          content="Looking for a house for sale in Trichy? Explore premium individual houses and villas with Mitha Homes."
        />
        <meta
          name="twitter:image"
          content="https://mithahomes.com/backend/uploads/OG_banner_image.png"
        />
      </Helmet>

      {/* ---------------- PAGE CONTENT ---------------- */}
      <Navbardesign />
      <div style={{ height: isMobile ? "60px" : "90px" }} />

      <BannerSwiper />

      <HouseProjectSection />

      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>
        }
      >
        <Testimonials />
      </Suspense>

      <Footer />
      <ContactBar />

      {/* ---------------- POPUP MODAL ---------------- */}
      {showModal && popupImage && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
              cursor: "pointer",
            }}
          >
            <img
              src={popupImage}
              alt="Promotion"
              onClick={handlePopupClick}
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                borderRadius: "8px",
                display: "block",
              }}
            />
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "-12px",
                right: "-12px",
                background: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                fontSize: "18px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LandingPageHouseTrichy;
